<!--                                                v-on:click.native="goto(publication.url)"-->
<template>
    <section id="datasets" class="gradient" style="min-height: 600px; color:#FFF">
        <mdb-container class="py-5">
            <mdb-row>
                <mdb-col md="6">
                    <h6 class="section-header-top">Open sourced</h6>
                    <h2>DATASETS</h2>
                    <hr class="hr-bold"/>
                </mdb-col>
            </mdb-row>

            <mdb-row class="">
                <mdb-col xl="6" lg="6" md="6" class="mb-lg-0 mb-5 mt-5">
                    <mdb-view hover>
                        <mdb-card>
                            <mdb-card-body>
                                <mdb-card-title class="text-dark text-uppercase font-weight-light"
                                                style="min-height: 100px; max-height:80px; overflow:hidden; letter-spacing: 0.08em;"
                                ><router-link to="/corrosion_dataset#corrosionDatasetID"><a style="color: black">Corrosion Image Data Set for Automating Scientific Assessment of Materials</a></router-link>
                                </mdb-card-title>
                                <div>
                                    <mdb-card-text
                                            style="min-height: 100px; max-height:100px; overflow:hidden;">
                                        Biao Yin, Nicholas Josselyn, Thomas Considine, John Kelley, Berend Rinderspacher, Robert Jensen, James Snyder, Ziming Zhang, and Elke Rundensteiner
                                    </mdb-card-text>
                                </div>
                                <div style="position: absolute;bottom: 20px;">
                                    <mdb-card-text style="color: darkgoldenrod;">BMVC 2021</mdb-card-text>
                                </div>
                            </mdb-card-body>
                        </mdb-card>
                    </mdb-view>
                </mdb-col>
            </mdb-row>
        </mdb-container>
    </section>
</template>

<script>
    import {
        mdbContainer,
        mdbRow,
        mdbCol,
        mdbCard,
        mdbCardBody,
        mdbCardTitle,
        mdbCardText,
        mdbMask,
        mdbView,
        mdbModal,
        mdbModalHeader,
        mdbModalTitle,
        mdbModalBody,
        mdbModalFooter,
        mdbBtn,
    } from 'mdbvue';

    export default {
        name: "Publications",
        components: {
            mdbContainer,
            mdbRow,
            mdbCol,
            mdbCard,
            mdbCardBody, mdbCardTitle, mdbCardText,
            // mdbMask,
            mdbView,
            // mdbMask,
            // mdbView,
            // mdbModal,
            // mdbModalHeader,
            // mdbModalTitle,
            // mdbModalBody,
            // mdbModalFooter,
            // mdbBtn,
        },
        data(){
            return{modal: false}
        },
        methods: {
            goto: function (url) {
                window.location.href = url;
            }
        }
    }

</script>

<style scoped>
    .gradient {
        background-color: #778899;
        min-height: 450px;
        max-height: 450px;
        /*min-width: 330px;*/
        /*max-width: 330px;*/
    }

    .card-body {
        /* background: #778899; */
    }

</style>
